import { Component, OnInit, Inject, Injectable, LOCALE_ID } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from 'src/app/pages/common/api.service';
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class DetectLocation {
  userLocation: any;
  allInternationalCountries = [];
  public availableTranslatedLanguages = ["english", "japanese"]
  constructor(@Inject(DOCUMENT) private document: any,private _apiService: ApiService, @Inject(LOCALE_ID) public locale: string) {}
  getInternationalGeoLocation() {
    if(!localStorage.getItem("userLocation")){
      if (!this.allInternationalCountries || (this.allInternationalCountries && this.allInternationalCountries.length < 2)) {
        this.getAllInternationalCountries();
      }
      else{
        this.checkLocation();
      }
    }
  }
  getAllInternationalCountries() {
    this._apiService.getAllCountries().subscribe(
      (res: any) => {
        this.allInternationalCountries = res.data;
        this.checkLocation();
      });
  }
  checkLocation() {
    if (localStorage.getItem("userLocation")) {
      this.userLocation = JSON.parse(localStorage.getItem("userLocation"));
      this.checkCordinates(this.userLocation.latitude + "," + this.userLocation.longitude);
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.userLocation = position.coords;
          localStorage.setItem("userLocation", JSON.stringify({latitude: position.coords.latitude, longitude: position.coords.longitude}));
          this.checkCordinates(this.userLocation.latitude + "," + this.userLocation.longitude);
        }
      );
    }
  }
  checkCordinates(param) {
    this._apiService.checkCordinates(param).subscribe(
      (res: any) => {
        if (res && res.results[0] && res.results[0].components) {
            let county = null;
            let state = null;

            let country = res.results[0].components.country.toLowerCase();
            if (res.results[0].components.county) {
              county = res.results[0].components.county.toLowerCase();
            }
            else if (res.results[0].components.city) {
              county = res.results[0].components.city.toLowerCase();
            }
            if (res.results[0].components.state) {
              state = res.results[0].components.state.toLowerCase();
            }

            this.processLocation({county:county, country:country, state: state});
        }
      },
      () => {

      }
    );
  }
  processLocation(data) {
    let userCountry = this.allInternationalCountries.find((x) => { return x.attributes.name.toLowerCase() == data.country })
    if (userCountry) {
      this.userLocation = data;
      this.userLocation['country'] = userCountry;
      this._apiService.getAllCities({country_id: this.userLocation.country.id}).subscribe((res: any) => {
        if(res && res.data && res.data.length > 0){
          let userState = res.data.filter((item) => {
            return item.attributes.name.toLowerCase() == this.userLocation.state
          });
          if(userState && userState.length > 0){
            this.userLocation.state = userState[0].attributes;
          }
          localStorage.setItem("userLocation", JSON.stringify(this.userLocation));
        }
        else{
          localStorage.setItem("userLocation", JSON.stringify(this.userLocation));
        }
      });
    }
  }
  public setLanguage(lang, defaultCountryLang = false, pageReload = false) {
    sessionStorage.setItem("userLanguage", JSON.stringify(lang));
    if (this.locale !== lang?.attributes?.iso639_1 && (!defaultCountryLang || this.locale === 'en')) {
      let additionalPath = '';
      if (window.location.pathname?.includes('/en/')) {
        additionalPath = window.location.pathname.replace('/en/', '')
      } else if (window.location.pathname?.includes('/ja/')) {
        additionalPath = window.location.pathname.replace('/ja/', '')
      };
      window.open(`${environment.appLink}/${lang?.attributes?.iso639_1}/${additionalPath}`, '_self')
    } else {
      if (pageReload) {
        location.reload();
      }
    }
  }
}
